import React from 'react';

import { Button, Loading } from 'design-system-web';
import { AdminPage } from 'components';
import { Alert, AlertType } from 'components/lds';

import { useLabels } from '../../i18n/useLabels';
import { BREADCRUMBS } from '../../viewmodels/createTemplateCustomizationViewModel';
import type { PageStatus } from '../../viewmodels/resolvePageStatus';
import { TemplateCustomizationBreadcrumbs } from './TemplateCustomizationBreadcrumbs';

import styles from './TemplateCustomizationLayout.scss';

type Props = {
  status: PageStatus;
  listPageUrl: string;
  handleRetry: () => void;
  children: React.ReactNode;
};

export function PageState({
  status,
  listPageUrl,
  handleRetry,
  children,
}: Props) {
  const labels = useLabels();

  if (status === 'ready') {
    return children;
  }

  return (
    <AdminPage className={styles.adminPage}>
      <div className={styles.state}>
        {status === 'loading' && (
          <div role="status" aria-label={labels.loading}>
            <Loading />
          </div>
        )}
        {status !== 'loading' && status !== 'missingContext' && (
          <TemplateCustomizationBreadcrumbs
            viewModel={BREADCRUMBS}
            listPageUrl={listPageUrl}
          />
        )}
        {status === 'missingContext' && (
          <Alert type={AlertType.error} fullWidth>
            {labels.missingContext}
          </Alert>
        )}
        {status === 'notFound' && (
          <Alert type={AlertType.error} fullWidth>
            {labels.notFound}
          </Alert>
        )}
        {status === 'error' && (
          <>
            <Alert type={AlertType.error} fullWidth>
              {labels.loadError}
            </Alert>
            <Button
              variant="secondary"
              size="large"
              testId="retry-load"
              onClick={handleRetry}
            >
              {labels.retry}
            </Button>
          </>
        )}
      </div>
    </AdminPage>
  );
}
